import logo from './assets/logo_wa.png';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from './auth/Auth';
import { RequireAuth } from './auth/RequireAuth';
import routes from './Routes';
import { AppProvider } from './AppContext';
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { whatsappConfig } from './whatsappConfig';
function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {routes.map((route, index) => (
              <Route path={route.path} key={index} index element={
                <>
                  <main className="flex-shrink-0">
                    {route.header && <route.header />}
                    {route.innerBanner && <route.innerBanner />}
                    {route.leftSide && <route.leftSide />}
                    {route.auth ? <RequireAuth> <route.component /> </RequireAuth> : <route.component />}
                    <FloatingWhatsApp {...whatsappConfig} />
                  </main>
                  {route.footer && <route.footer />}
                </>
              } />
            ))}
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
